import { Component, Input } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import type { ToastPositionType } from 'primeng/toast';

@Component({
    selector: 'app-toast',
    imports: [ToastModule],
    template: `
    <p-toast
      [key]="key"
      [position]="position"
      appendTo="body"
      [autoZIndex]="true"
      [baseZIndex]="baseZIndex">
    </p-toast>
  `
})
export class ToastComponent {
  @Input() key: string = 'global';
  @Input() position: ToastPositionType = 'top-right';
  @Input() baseZIndex = 999999; // Match global styles - always on top
}
